import debounce from 'lodash/debounce';

const _debounce = debounce
export default _debounce;
